import { useEffect, useState} from 'react'
import moment from 'moment'
import { deleteRestrictedAppointmentDates, getRestrictedAppointmentDates } from '../../../../Adaptor/TUBSIS'
import { GetRestrictedAppointmentDatesOutput } from '../../../../Adaptor/TUBSIS/controllers/RestrictedAppointmentDates/models/getRestrictedAppointmentDates'
import RestrictedAppointmentDatesCreate from './RestrictedAppointmentDatesCreate'
import RestrictedAppointmentDatesUpdate from './RestrictedAppointmentDatesUpdate'

const RestrictedAppointmentDatesTable = () => { 
  
  const [restrictedAppointmentDateList, setRestrictedAppointmentDateList] = useState<GetRestrictedAppointmentDatesOutput[] | null>(null)
  const [selectedRestrictedAppointmentDate, setSelectedRestrictedAppointmentDate] = useState<GetRestrictedAppointmentDatesOutput | null>(null)
  
    useEffect(() => {
      if (!restrictedAppointmentDateList) {
        getRestrictedAppointmentDates()
        .then((response) => {
          ////debugger
          setRestrictedAppointmentDateList(response.data)
        })
        .catch((error) => {
          ////debugger
          console.log(error)
        })
      }
    })

const handleDeleteClick = (id: number) => {
    // Silme işlemine başlamadan önce kullanıcıyı uyaralım
    const isConfirmed: boolean = window.confirm("Randevu kısıtlama tarihini silmek istiyor musunuz?");

    // Eğer kullanıcı silmeyi onaylarsa devam edelim
    if (isConfirmed) {
        // Silme işlemini gerçekleştir
        deleteRestrictedAppointmentDates(id)
        .then((response) => {
          ////debugger
          //console.log("delete",response.data)

          // Silinecek kısıtı filtrele
          const updatedRestricteds = restrictedAppointmentDateList?.filter(restriction => restriction.id !== id);
            
          // Güncellenmiş kısıt listesini state'e uygula
          setRestrictedAppointmentDateList(updatedRestricteds??[]);
        })
        .catch((error) => {
          ////debugger
          console.log(error)
        })
    }
};

    return (
        <div className='card p-5'>
            <div className='card-header'>
                <div className='d-flex align-items-center'>
                </div>
                <RestrictedAppointmentDatesCreate/>
            </div>
            <div className='card-body'> 
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    {/* <!--begin::Table head--> */}
                    <thead>
                        <tr className="fw-bold text-gray-600">
                            <th className="w-25px">
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check"/>
                                </div>
                            </th>
                            {/* <th className="min-w-200px">Uzman</th> */}
                            <th className="min-w-150px">Başlangıç Tarihi</th>
                            <th className="min-w-150px">Bitiş Tarihi</th>
                            <th className="min-w-150px">Kısıtlama Sebebi</th>
                            <th className="min-w-150px">Oluşturma Tarihi</th>
                            <th className="min-w-100px text-end">İşlemler</th>
                        </tr>
                    </thead>
                    {/* <!--end::Table head--> */}

                    {/* table body began */}

                    {restrictedAppointmentDateList && restrictedAppointmentDateList.length > 0 ? (
                    <tbody>
                        {restrictedAppointmentDateList.map((restriction, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                                        <input className="form-check-input widget-9-check" type="checkbox" value="1"/>
                                    </div>
                                </td>

                                <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">
                                                {moment(restriction.startDate).format('DD MMMM YYYY')}
                                            </span>
                                        </div>
                                    </div>
                                </td>

                                <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">
                                                {moment(restriction.endDate).format('DD MMMM YYYY')}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-start flex-column">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{restriction.descriptions}</span>
                                        </div>
                                    </div>                                
                                </td>

                                <td className="text-end">
                                    <div className="d-flex flex-column w-100 me-2">
                                        <div className="d-flex flex-stack mb-2">
                                            <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">
                                                {moment(restriction.restrictionDate).format('DD MMMM YYYY HH:mm')}
                                            </span>
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <div className="d-flex justify-content-end flex-shrink-0">

                                        <RestrictedAppointmentDatesUpdate restriction={restriction}/>

                                        <button 
                                            type="button" 
                                            title='Randevuyu Sil'
                                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm" 
                                            onClick={() => handleDeleteClick(restriction.id)}>
                                            <i className="ki-duotone ki-trash fs-2"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></i>                                    
                                        </button>

                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>)
                : (
                    <tbody>
                        <tr>
                            <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                    <input className="form-check-input widget-9-check" type="checkbox" value="1" disabled/>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start flex-column">
                                        <span className="text-gray-400 fw-bold text-hover-primary d-block fs-6">RANDEVU KISITLAMA TARİHİ BULUNAMADI.</span>
                                    </div>
                                </div>     
                                {/* <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                    <div className="fs-3 text-muted">Randevu Bulunamadı.</div>
                                </div> */}
                            </td>
                        </tr>
                    </tbody>)}
                </table>
            </div>
      </div>
    )
}

export default (RestrictedAppointmentDatesTable)